<template>
  <div ref="chartContainer" style="width: 100%; height: 320px"></div>
</template>

<script>
export default {
  props: {
    option: {
      type: Object,
      required: true
    },
    theme: {
      type: String,
      default: 'shine'
    }
  },
  data() {
    return {
      chartInstance: null,
      isMounted: false
    };
  },
  mounted() {
    this.isMounted = true;
    this.ensureEchartsLoaded().then(() => {
      this.safeInitChart();
    }).catch(error => {
      console.error('初始化图表失败:', error);
    });
  },
  beforeDestroy() {
    this.safeDisposeChart();
  },
  watch: {
    option: {
      handler(newOption) {
        if (this.chartInstance) {
          this.$nextTick(() => {
            this.chartInstance.setOption(newOption, true);
          });
        }
      },
      deep: true
    },
    theme(newTheme) {
      if (this.chartInstance) {
        this.$nextTick(() => {
          this.refreshChart(newTheme);
        });
      }
    }
  },
  methods: {
    // 确保ECharts已加载
    ensureEchartsLoaded() {
      return new Promise((resolve, reject) => {
        if (typeof echarts !== 'undefined') {
          return resolve();
        }

        // 动态加载ECharts
        // const script = document.createElement('script');
        // script.src = 'https://cdn.jsdelivr.net/npm/echarts@5.4.3/dist/echarts.min.js';
        // script.onload = resolve;
        // script.onerror = reject;
        // document.head.appendChild(script);
      });
    },

    // 安全的初始化图表
    safeInitChart() {
      if (!this.isMounted || !this.$refs.chartContainer) {
        return;
      }

      try {
        this.chartInstance = echarts.init(this.$refs.chartContainer, this.theme);
        this.chartInstance.setOption(this.option);
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
      } catch (error) {
        console.error('初始化图表时出错:', error);
      }
    },

    // 安全的销毁图表
    safeDisposeChart() {
      if (this.chartInstance) {
        try {
          window.removeEventListener('resize', this.handleResize);
          this.chartInstance.dispose();
          this.chartInstance = null;
        } catch (error) {
          console.error('销毁图表时出错:', error);
        }
      }
    },

    handleResize() {
      if (this.chartInstance && this.$refs.chartContainer) {
        this.chartInstance.resize();
      }
    },

    refreshChart(theme) {
      this.safeDisposeChart();
      this.safeInitChart(theme);
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

div {
  margin-top: 10px;
}
</style>